import axios from "axios";
import { useEffect, useState } from "react";
import { SERVER_BASE_URL } from "../config";
import { Card, Flex, Spin } from "antd";
import { useLocation } from "react-router-dom";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const RecordingPage = () => {
  const location = useLocation();
  let searchParams = new URLSearchParams(location.search);

  const [meta, setMeta] = useState({ title: "" });
  const [audioUrl, setAudioUrl] = useState(null);

  useEffect(() => {
    const fetchAudio = async () => {
      const response = await axios.get(
        `${SERVER_BASE_URL}/call/get_recording`,
        {
          responseType: "blob", // important!
          params: {
            url: encodeURIComponent(searchParams.get("url")),
            organization_id: searchParams.get("org_id"),
          },
        }
      );

      const recording_url = searchParams.get("url");
      if (recording_url) {
        const match = recording_url.match(/-(\d+)_([\d]{14})/);

        if (match) {
          setMeta((prev) => ({ ...prev, title: `${match[1]}` }));
        }
      }

      const blob = new Blob([response.data], { type: "audio/wav" });
      const url = URL.createObjectURL(blob);
      setAudioUrl(url);
    };

    const recording_url = searchParams.get("url");
    if (recording_url) {
      const split_1 = recording_url.split("_");

      console.log(split_1);
    }

    if (searchParams.get("org_id") && searchParams.get("url")) fetchAudio();
  }, []);

  if (!audioUrl) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: "70vh" }}>
        <Spin spinning></Spin>
      </Flex>
    );
  }

  const downloadButton = (
    <a
      href={audioUrl}
      download
      title="Download"
      style={{ marginLeft: 8, color: "inherit" }}
    >
      <CloudDownloadIcon />
    </a>
  );

  return (
    <div className="recording_cont">
      <Card title={meta?.title}>
        <AudioPlayer
          src={audioUrl}
          showJumpControls={false}
          showFilledProgress={false}
          showFilledVolume
          customAdditionalControls={[downloadButton]}
        />
      </Card>
    </div>
  );
};

export default RecordingPage;
